import { Component, Input } from '@angular/core';
import { BreadcrumbItem } from './breadcrumb-item.model';

@Component({
  selector: 'lineup-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false
})
export class BreadcrumbsComponent {
  @Input() items: BreadcrumbItem[] = [];
}
